module.exports = __webpack_public_path__ + "img/MS_WeaponSword008.945ae703.png";